"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Footer = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactBootstrap = require("react-bootstrap");
var _classnames = _interopRequireDefault(require("classnames"));
var _FooterModule = _interopRequireDefault(require("./Footer.module.css"));
var _excluded = ["showHeader"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var headerItems = [{
  label: 'სპორტის სიახლეები',
  path: '#',
  external: true
}, {
  label: 'სალაროები',
  path: '#',
  external: false
}, {
  label: 'კონტაქტი',
  path: '#',
  external: false
}, {
  label: 'წესები და პირობები',
  path: '#',
  external: false
}, {
  label: 'რეგლამენტი',
  path: '#',
  external: false
}];
var gameItems = [{
  label: 'სპორტი',
  path: '#'
}, {
  label: 'სეკა',
  path: '#'
}, {
  label: 'ლაივი',
  path: '#'
}, {
  label: 'ნარდი',
  path: '#'
}, {
  label: 'ვირტ.ფეხბურთი',
  path: '#'
}, {
  label: 'დომინო',
  path: '#'
}, {
  label: 'ვირტ.ჩოგბურთი',
  path: '#'
}, {
  label: 'ვოლტი',
  path: '#'
}, {
  label: 'ვირტ.კალათბურთი',
  path: '#'
}, {
  label: 'პოკერი',
  path: '#'
}, {
  label: 'კენო',
  path: '#'
}, {
  label: 'ელ.რულეტი',
  path: '#'
}];
var newsItems = [{
  title: 'დადე ფსონი TOP ჩემპიონატებზე და მიიღე 100% 0.5 ლ ფრისპინი!',
  date: '2021.11.03',
  imgUrl: 'https://sportcache.lider-bet.com/news/img/5f5c87f647f1f695d3a1897a5ae366bf53488960.jpg',
  to: '#'
}, {
  title: '20 X ბინა ბათუმში!',
  date: '2021.10.29',
  imgUrl: 'https://sportcache.lider-bet.com/news/img/77ea3b0b402131a4447859d02a0bb5f01db8261f.jpg',
  to: '#'
}];
var Footer = function Footer(_ref) {
  var showHeader = _ref.showHeader,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("footer", {
    className: _FooterModule.default.footer
  }, showHeader && /*#__PURE__*/_react.default.createElement("ul", {
    className: _FooterModule.default.header
  }, headerItems.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement("li", {
      key: index
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: item.path,
      target: item.external ? '_blank' : '_self',
      className: _FooterModule.default.link
    }, item.label));
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
    className: _FooterModule.default.body
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    lg: 4,
    md: 6,
    className: (0, _classnames.default)(_FooterModule.default.col, _FooterModule.default.games)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _FooterModule.default.title
  }, /*#__PURE__*/_react.default.createElement("h2", null, "\u10D7\u10D0\u10DB\u10D0\u10E8\u10D4\u10D1\u10D8"), /*#__PURE__*/_react.default.createElement("a", {
    href: "#",
    className: _FooterModule.default.imgContainer
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: "https://www.lider-bet.com/gui/web/images/idq.png"
  }))), /*#__PURE__*/_react.default.createElement("ul", {
    className: _FooterModule.default.content
  }, gameItems.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement("li", {
      key: index
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: item.path
    }, item.label));
  }))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    lg: 4,
    md: 6,
    className: (0, _classnames.default)(_FooterModule.default.col, _FooterModule.default.news)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _FooterModule.default.title
  }, /*#__PURE__*/_react.default.createElement("h2", null, "\u10E1\u10D8\u10D0\u10EE\u10DA\u10D4\u10D4\u10D1\u10D8"), /*#__PURE__*/_react.default.createElement("a", {
    href: "/news"
  }, "\u10E7\u10D5\u10D4\u10DA\u10D0\u10E1 \u10DC\u10D0\u10EE\u10D5\u10D0")), /*#__PURE__*/_react.default.createElement("ul", {
    className: _FooterModule.default.content
  }, newsItems.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement("li", {
      key: index
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _FooterModule.default.imgContainer,
      style: {
        backgroundImage: "url(".concat(item.imgUrl, ")")
      }
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: _FooterModule.default.details
    }, /*#__PURE__*/_react.default.createElement("span", null, item.date), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("a", {
      href: item.to
    }, item.title)));
  }))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    lg: 4,
    md: 6,
    className: (0, _classnames.default)(_FooterModule.default.col, _FooterModule.default.contact)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _FooterModule.default.title
  }, /*#__PURE__*/_react.default.createElement("h2", null, "\u10D9\u10DD\u10DC\u10E2\u10D0\u10E5\u10E2\u10D8"), /*#__PURE__*/_react.default.createElement("div", {
    className: _FooterModule.default.iconsContainer
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: "#"
  }), /*#__PURE__*/_react.default.createElement("a", {
    href: "#",
    style: {
      backgroundPosition: '-26px 0'
    }
  }), /*#__PURE__*/_react.default.createElement("a", {
    href: "#",
    style: {
      backgroundPosition: '-53px 0'
    }
  }), /*#__PURE__*/_react.default.createElement("a", {
    href: "#",
    style: {
      backgroundPosition: '-80px 0'
    }
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: _FooterModule.default.content
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
    className: (0, _classnames.default)(_FooterModule.default.row, _FooterModule.default.phone)
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement("a", null, /*#__PURE__*/_react.default.createElement("label", null, "\u10E1\u10D0\u10D8\u10DC\u10E4\u10DD\u10E0\u10DB\u10D0\u10EA\u10D8\u10DD"), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("span", null, "032"), " 2 19 55 00")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement("a", null, /*#__PURE__*/_react.default.createElement("label", null, "\u10EA\u10EE\u10D4\u10DA\u10D8 \u10EE\u10D0\u10D6\u10D8"), /*#__PURE__*/_react.default.createElement("br", null), "* 1010")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement("a", null, /*#__PURE__*/_react.default.createElement("label", null, "\u10E1\u10DE\u10DD\u10E0\u10E2\u10D8"), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("span", null, "032"), " 2 40 11 40"))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
    className: (0, _classnames.default)(_FooterModule.default.row, _FooterModule.default.viber)
  }, /*#__PURE__*/_react.default.createElement("a", null, /*#__PURE__*/_react.default.createElement("label", null, "\u10D5\u10D0\u10D8\u10D1\u10D4\u10E0\u10D8"), /*#__PURE__*/_react.default.createElement("br", null), "Viber \u10E9\u10D0\u10E2\u10D8")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
    className: (0, _classnames.default)(_FooterModule.default.row, _FooterModule.default.email)
  }, /*#__PURE__*/_react.default.createElement("a", null, /*#__PURE__*/_react.default.createElement("label", null, "\u10D4\u10DA.\u10E4\u10DD\u10E1\u10E2\u10D0"), /*#__PURE__*/_react.default.createElement("br", null), "support@lider-bet.com")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
    className: (0, _classnames.default)(_FooterModule.default.row, _FooterModule.default.points)
  }, /*#__PURE__*/_react.default.createElement("a", null, /*#__PURE__*/_react.default.createElement("label", null, "\u10E1\u10D0\u10DA\u10D0\u10E0\u10DD\u10D4\u10D1\u10D8"), /*#__PURE__*/_react.default.createElement("br", null), "\u10E1\u10D0\u10DA\u10D0\u10E0\u10DD\u10D4\u10D1\u10D8\u10E1 \u10E1\u10D8\u10D0"))))));
};
exports.Footer = Footer;
Footer.propTypes = {
  showHeader: _propTypes.default.bool
};
Footer.defaultProps = {
  showHeader: true
};